import { GridCellParams } from '@mui/x-data-grid';
import React from 'react';
import { Button } from '@mui/material';

export const LinkCell = (cellValues: GridCellParams) => {
    const link = cellValues.value as any;

    if (!link) {
        return;
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <Button sx={{ display: 'inline' }} target={'_blank'} href={link.url}>
                {link.name ? link.name : link.url}
            </Button>
        </div>
    );
};
